
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uGame/valentine",
      function () {
        return require("private-next-pages/uGame/valentine.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uGame/valentine"])
      });
    }
  